import type { FormKitNode } from '@formkit/core'
import icon from '@/assets/svg/dbc-icon-form-message.svg?raw'

export default function addValidationMessageIcon(node: FormKitNode) {
  node.on('created', () => {
    if (!node.context) return
    if (!node.props.definition) return
    if (typeof node.props.definition?.schema !== 'function') return

    const original = node.props.definition?.schema

    node.context.warningIcon = icon

    node.props.definition.schema = (extensions) => {
      if (!extensions.message) {
        extensions.message = {
          //@ts-ignore
          ...extensions.message,
          attrs: {
            innerHTML: '$warningIcon + " " + $message.value',
          },
          children: '',
        }
      }
      return original(extensions)
    }
  })
}
